var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('up-tags',{attrs:{"tags":_vm.versions,"is-loading":_vm.isLoading,"title":"Versions","button-text":"+ New Version","value-key":"tag"},on:{"remove":_vm.deleteVersion,"enter":_vm.addVersion}})}
var staticRenderFns = []

export { render, staticRenderFns }